import { URL_REGEX } from './urlPattern';

export interface UrlTextPart {
  readonly kind: 'text' | 'link';
  readonly text: string;
  readonly start: number;
}

export function splitUrlText(text: string): UrlTextPart[] {
  const parts: UrlTextPart[] = [];
  let cursor = 0;
  const matcher = new RegExp(URL_REGEX.source, URL_REGEX.flags);
  for (let match = matcher.exec(text); match; match = matcher.exec(text)) {
    let end = match.index;
    const brackets: string[] = [];
    while (end < text.length) {
      const char = text[end];
      // 복사한 주소의 한글 경로는 퍼센트 인코딩되므로 한글은 뒤따르는 문장으로 보고 링크를 끝낸다.
      if (!char || /[\s<>"'\p{Script=Hangul}]/u.test(char)) break;
      if (char === '(' || char === '[') brackets.push(char);
      else if (char === ')' || char === ']') {
        if (brackets.at(-1) !== (char === ')' ? '(' : '[')) break;
        brackets.pop();
      }
      end++;
    }
    matcher.lastIndex = end;
    const url = trimUrlEnd(text.slice(match.index, end));
    if (!hasHost(url)) continue;
    if (match.index > cursor)
      parts.push({ kind: 'text', text: text.slice(cursor, match.index), start: cursor });
    parts.push({ kind: 'link', text: url, start: match.index });
    cursor = match.index + url.length;
  }
  if (cursor < text.length) parts.push({ kind: 'text', text: text.slice(cursor), start: cursor });
  return parts;
}

// URL.canParse 는 Safari 17·Chrome 120 이후라 생성자 예외로 판정한다.
function hasHost(url: string): boolean {
  try {
    return new URL(url).hostname !== '';
  } catch {
    return false;
  }
}

function trimUrlEnd(url: string): string {
  const pairs = new Map([
    [')', '('],
    [']', '['],
    ['}', '{'],
  ]);
  const balance = new Map<string, number>();
  for (const char of url) {
    for (const [close, open] of pairs) {
      if (char === open) balance.set(close, (balance.get(close) ?? 0) + 1);
      if (char === close) balance.set(close, (balance.get(close) ?? 0) - 1);
    }
  }
  let end = url.length;
  while (end > 0) {
    const char = url[end - 1] ?? '';
    if ('.,;:!?'.includes(char)) end--;
    else if (pairs.has(char) && (balance.get(char) ?? 0) < 0) {
      balance.set(char, (balance.get(char) ?? 0) + 1);
      end--;
    } else break;
  }
  return url.slice(0, end);
}
